import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import ProductSubgroup from '../../models/ProductSubgroup';


export interface ProductSubgroupDetailState extends ApiState {
  productSubgroup?: ProductSubgroup
}

export default requestReducer<ProductSubgroupDetailState>('PRODUCTSUBGROUP_DETAIL')
